"use strict";

module.exports = require("./TinyOSS")["default"];